import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiExternalLink, FiEye, FiEyeOff, FiInfo } = FiIcons;
const DEMO_URL = 'https://jam.jellylocal.com/client-login';
const DEMO_EMAIL = 'andrew@jellylocal.com';
const DEMO_PASSWORD = 'manager1!';

export default function DemoAccount() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <section className="mt-8 rounded-3xl border border-slate-200 bg-slate-50 p-6 sm:p-8" aria-labelledby="demo-account-title">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">See the software in action</p>
          <h2 id="demo-account-title" className="mt-2 text-2xl font-black text-[#0b1423]">Partner demo account</h2>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-600">
            Sign in to explore the client experience and see how the software works.
          </p>
        </div>
        <a
          href={DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="site-button inline-flex shrink-0 items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-bold"
        >
          Open demo login <SafeIcon icon={FiExternalLink} />
        </a>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Username</p>
          <p className="mt-2 break-all font-semibold text-[#0b1423]">{DEMO_EMAIL}</p>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Password</p>
          <div className="mt-2 flex items-center justify-between gap-3">
            <p className="font-semibold text-[#0b1423]">{showPassword ? DEMO_PASSWORD : '•••••••••'}</p>
            <button
              type="button"
              onClick={() => setShowPassword((visible) => !visible)}
              aria-label={showPassword ? 'Hide demo password' : 'Show demo password'}
              className="rounded-lg p-2 text-slate-600 transition-colors hover:bg-slate-100"
            >
              <SafeIcon icon={showPassword ? FiEyeOff : FiEye} className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>

      <div className="mt-5 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-amber-950">
        <SafeIcon icon={FiInfo} className="mt-0.5 h-5 w-5 shrink-0" />
        <p className="text-sm leading-relaxed">
          <strong>This is a live account.</strong> Please look around, but do not change, add, delete, or publish anything.
        </p>
      </div>
    </section>
  );
}